module.exports = __webpack_public_path__ + "img/why-energy.9baee11.png";